import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import supabase from "../supabase";

export default function Login() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");

  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const [signupFullName, setSignupFullName] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPassword, setSignupPassword] = useState("");

  // --------------------------
  // LOGIN WITH SUPABASE
  // --------------------------
  const handleLogin = async (e) => {
    e.preventDefault();

    const { data, error } = await supabase.auth.signInWithPassword({
      email: loginEmail,
      password: loginPassword,
    });

    if (error) {
      alert("Login failed: " + error.message);
      return;
    }

    alert("Login successful!");
    navigate("/home");
  };

  // --------------------------
  // SIGNUP WITH SUPABASE
  // --------------------------
  const handleSignup = async (e) => {
    e.preventDefault();

    const { data, error } = await supabase.auth.signUp({
      email: signupEmail,
      password: signupPassword,
      options: {
        data: { full_name: signupFullName }
      },
    });

    if (error) {
      alert("Signup failed: " + error.message);
      return;
    }
    const token = data.session?.access_token;
    localStorage.setItem("token", token);

    // Immediately create the root member
    await fetch("https://fta-backend-javascript.onrender.com/members", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        name: "You",
        parents: [],
        children: []
      })
    });

    alert("Signup successful! Check your email for confirmation.");
    setActiveTab("login");
  };

  return (

    <div class="layout">
      <div class="block block-login">
        <div className="form">
          {/* <h2>Welcome Back</h2> */}

          <ul className="tab-group">
            <li className={activeTab === "login" ? "tab active" : "tab"}>
              <a onClick={() => setActiveTab("login")}>Login</a>
            </li>
            <li className={activeTab === "signup" ? "tab active" : "tab"}>
              <a onClick={() => setActiveTab("signup")}>Sign Up</a>
            </li>
          </ul>

          <div className="tab-content">
            {/* LOGIN */}
            <div id="login" style={{ display: activeTab === "login" ? "block" : "none" }}>
              <h1>Login</h1>
              <form onSubmit={handleLogin}>
                <div className="field-wrap">
                  <label>Email*</label>
                  <input
                    type="email"
                    value={loginEmail}
                    onChange={(e) => setLoginEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="field-wrap">
                  <label>Password*</label>
                  <input
                    type="password"
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                    required
                  />
                </div>

                <button className="button button-block" type="submit">Log In</button>
              </form>
            </div>

            {/* SIGNUP */}
            <div id="signup" style={{ display: activeTab === "signup" ? "block" : "none" }}>
              <h1>Create Account</h1>
              <form onSubmit={handleSignup}>
                <div className="field-wrap">
                  <label>Full Name*</label>
                  <input
                    type="text"
                    value={signupFullName}
                    onChange={(e) => setSignupFullName(e.target.value)}
                    required
                  />
                </div>

                <div className="field-wrap">
                  <label>Email*</label>
                  <input
                    type="email"
                    value={signupEmail}
                    onChange={(e) => setSignupEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="field-wrap">
                  <label>Password*</label>
                  <input
                    type="password"
                    value={signupPassword}
                    onChange={(e) => setSignupPassword(e.target.value)}
                    required
                  />
                </div>

                <button className="button button-block" type="submit">Sign Up</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="block block-info">
        <h1>Family Tree</h1>
        <p>Our startup is building a Digital Family Story Tree for preserving family memories.</p>
        <p>The application lets each family member add stories, photos, recipes, and advice in one shared space.</p>
        <p>Memories grow visually like a tree, making it easy and engaging to explore family history across generations.</p>
        <p>The goal is to prevent traditions and personal stories from being lost or scattered across devices and apps.</p>
        <p>ЕWe focus on emotional connection, collaborative storytelling, and long-term preservation of family heritage.</p>
        
      </div>
    </div>

  );
}
